/**
 * The family names, in Slovak, for the back office.
 *
 * The achievement *names and descriptions* a child reads come from the API's message catalogue and are
 * never restated here. A family code has no catalogue entry — it is an internal grouping that never reaches
 * a child — so this is the one place the back office is allowed to name something itself.
 */
export const FAMILY_LABEL: Record<string, string> = {
  consistency: 'Pravidelnosť',
  persistence: 'Vytrvalosť',
  return: 'Návrat',
  skill: 'Zručnosti',
  breadth: 'Rozhľad',
  effort: 'Úsilie',
  recovery: 'Zvládnutie',
  reading: 'Čítanie',
  expression: 'Vyjadrovanie',
  island: 'Ostrov',
};
